const stripTrailingSlash = (u: string) => u.replace(/\/+$/, '')

export const HOME_URL = stripTrailingSlash(
  (import.meta.env.VITE_HOME_URL as string | undefined) ?? 'https://vndta.cc'
)

export const CDN_URL = stripTrailingSlash(
  (import.meta.env.VITE_CDN_URL as string | undefined) ?? 'https://cdn.vndta.cc'
)

export const WORKER_URL = CDN_URL

// Files under `image/` are gated at the edge and served EXCLUSIVELY by the
// image subdomain (img.vndta.cc). Any other host → 404. Unlike AMP the host is
// fixed (no rotation), so a static config value is enough.
export const IMAGE_URL = stripTrailingSlash(
  (import.meta.env.VITE_IMAGE_URL as string | undefined) ?? 'https://img.vndta.cc'
)

const isImagePath = (filePath: string) => {
  const p = filePath.replace(/^\/+/, '')
  return p === 'image' || p.startsWith('image/')
}

// Files under `amp/` are gated at the edge: cdn.vndta.cc/amp/* → 404. They can
// only be served through the currently-active AMP subdomain. When the caller
// knows the active host (fetched via /api/auth/status), route AMP paths there;
// otherwise fall back to CDN so the URL still shows something sensible
// (which will 404, telling the caller the AMP host is unset).
const isAmpPath = (filePath: string) => {
  const p = filePath.replace(/^\/+/, '')
  return p.startsWith('amp/') || p.includes('/amp/')
}

// authStore persists the active AMP host to this localStorage key. Reading it
// here lets pure URL builders stay caller-agnostic (no need to thread the host
// through every component that renders a preview/download link).
const getStoredAmpHost = (): string | null => {
  try { return window.localStorage?.getItem('vendetta-amp-host') || null } catch { return null }
}

export const publicFileUrl = (filePath: string, activeAmpHost?: string | null) => {
  const clean = filePath.replace(/^\/+/, '')
  if (isImagePath(clean)) {
    return `${IMAGE_URL}/${clean}`
  }
  const host = activeAmpHost ?? getStoredAmpHost()
  if (isAmpPath(clean) && host) {
    return `https://${host}/${clean}`
  }
  return `${CDN_URL}/${clean}`
}

export const downloadUrl = (filePath: string, activeAmpHost?: string | null) =>
  `${publicFileUrl(filePath, activeAmpHost)}?download=1`
